import { render, staticRenderFns } from "./loginWait.vue?vue&type=template&id=555af13b&scoped=true&"
import script from "./loginWait.vue?vue&type=script&lang=js&"
export * from "./loginWait.vue?vue&type=script&lang=js&"
import style0 from "./loginWait.vue?vue&type=style&index=0&id=555af13b&prod&lang=scss&scoped=true&"
import style1 from "./loginWait.vue?vue&type=style&index=1&id=555af13b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555af13b",
  null
  
)

export default component.exports